import { EmployeesJobDocument, EmployeesJobQueryVariables } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useEmployeeJobTitle = (variables: EmployeesJobQueryVariables) => {
  const { loading, data } = useQuery(EmployeesJobDocument, { variables })

  return {
    loading: loading,
    employeeJobs: data?.contracts.referenceContractsConnection.nodes ?? [],
  }
}
